module.exports = __webpack_public_path__ + "static/media/warlock.01d2c40b.png";